import axios from './apiconfig.js'
function fetch (requestUrl, params, headers, flag, requestWay) { // contentType=1 multipart/form-data;
  return axios({
    flag: flag,
    url: requestUrl,
    method: !requestWay ? 'post' : 'get',
    data: params
  })
}
const interfaces = {
  getMachinePhysicalDetail: (data) => { // 获取token
    return fetch('/AppPhysical/GetMachinePhysicalDetail', data)
  },
  getAIResult: (data) => { // 获取AI结果
    return fetch('https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions', data)
  },
  getRegionTree: (data) => { // 获取token
    return fetch('/Region/GetRegionTree', data)
  },
  getWechatSign: (data) => { // 分页获取地址
    return fetch('/Wechat/GetWechatSign', data)
  },
  getCheckVersionInfo: (data) => { // 获取K800广告页二维码图片
	  return fetch('/System/CheckVersionInfo', data)
  },
  getSysAgencyDetectionByPage: (data) => { // 分页获取检测点
    return fetch('/SysAgency/GetSysAgencyDetectionByPage', data)
  },
  getAddressByPage: (data) => { // 分页获取地址
    return fetch('/Address/GetByPage', data)
  },
  getClubPageByCondtion: (data) => { // 获取所有的会所分页列表接口
    return fetch('/Club/GetClubPageByCondtion', data)
  },
  getClubDetailByClubId: (data) => { // 获取所有的会所详情接口
    return fetch('/Club/GetClubDetailByClubId', data)
  },
  getClubProductDetailById: (data) => { // APP获取会所项目详情
    return fetch('/Club/GetClubProductDetailById', data)
  },
  getClubOrderByPage: (data) => { // C端获取会所订单分页列表
    return fetch('/Order/GetClubOrderByPage', data)
  },
  getClubOrderDetailById: (data) => { // C端获取会所订单详情
    return fetch('/Order/GetClubOrderDetailById', data)
  },
  getOrderConfirm: (data) => { // C端用户主动核销会所订单
    return fetch('/Admin/Order/OrderConfirm', data)
  },
  getMemOrderRefundApply: (data) => { // C端用户主动发起会所订单退款申请
    return fetch('/Order/MemOrderRefundApply', data)
  },
  appPay: (data) => { // ios andriod支付 已有订单号
    return fetch('/Payment/AppPay', data)
  },
  staff: (data) => { // 客服人员
    return fetch('/Refund/QRcode', data)
  },
  addAddress: (data) => { // 添加地址
    return fetch('/Address/Add', data)
  },
  getRegions: (data) => { // 获取省市区 code 为空 差所有,code 为-1 差省一级
    return fetch('/Admin/Common/GetRegions', data)
  },
  updateAddress: (data) => { // 修改
    return fetch('/Address/update', data)
  },
  createOrder: (data) => { // 创建订单
    return fetch('/Order/Create', data)
  },
  getLogisticsTracking: (data) => { // 获取物流追踪信息
    return fetch('/Order/GetLogisticsTracking', data)
  },
  receiveGoods: (data) => { // /api/v{api-version}/Order/Receive  客户端确认收货
    return fetch('/Order/Receive', data)
  },
  reCreate: (data) => { // Order/ReCreate  再次添加进购物车
    return fetch('/Order/ReCreate', data)
  },
  getByOrderId: (data) => { // 订单详情  根据  orderId  GetByOrderId
    return fetch('/Order/GetByOrderId', data)
  },
  cancelOrder: (data) => { // 取消订单
    return fetch('/Order/Cancel', data)
  },
  getPaymentOrderByPaymentOrderId: (data) => { // 根据PaymentOrderId获取订单信息  只有待付款状态
    return fetch('/Order/GetPaymentOrderByPaymentOrderId', data)
  },
  createByCart: (data) => { // /Order/CreateByCart  购物车创建订单
    return fetch('/Order/CreateByCart', data)
  },
  getOrderByPage: (data) => { // 获取订单列表 订单状态：1待付款2已取消3待发货4待收货5已完成6已退款
    return fetch('/Order/GetByPage', data)
  },
  deleteAddress: (data) => { // 删除
    return fetch('/Address/Delete', data)
  },
  getSingleAddress: (data) => { // 获取单个地址
    return fetch('/Address/Single', data)
  },
  GetGoodsByPage: (data) => { // 获取商品列表
    return fetch('/Goods/GetByPage', data)
  },
  GetGoodsDetail: (data) => { // 获取商品列表详情
    return fetch('/Goods/GetDetail', data)
  },
  GetCartByPage: (data) => { // 获取购物车分页列表
    return fetch('/Cart/GetByPage', data)
  },
  AddToCart: (data) => { // 添加购物车
    return fetch('/Cart/AddToCart', data)
  },
  GetCartItemCount: (data) => { // 获取购物车数量
    return fetch('/Cart/GetCartItemCount', data)
  },
  DeleteItem: (data) => { // Cart/DeleteItem  删除购物车
    return fetch('/Cart/DeleteItem', data)
  },
  UpdateItemQuantity: (data) => { //  更新购物车商品数量
    return fetch('/Cart/UpdateItemQuantity', data)
  },
  GetWikiDetial: (data) => {
    return fetch('/Wiki/GetWikiDetial', data)
  },
  GetWikiEncyByPage: (data) => {
    return fetch('/Wiki/GetWikiEncyByPage', data)
  },
  getSaaSWikiNewsByPage: (data) => {
    return fetch('/WiKi/GetSaaSWikiNewsByPage', data)
  },
  GetAppWiKiCategoryByPage: (data) => {
    return fetch('/Wiki/GetAppWiKiCategoryByPage', data)
  },
  GetSaaSWiKiCategoryByPage: (data) => { // 获取百科类型
    return fetch('/WiKi/GetSaaSWiKiCategoryByPage', data)
  },
  GetSaaSWikiEncyByPage: (data) => { // 分页获取百科下子项
    return fetch('/WiKi/GetSaaSWikiEncyByPage', data)
  },
  GetFrontHealthWiKiDetailById: (data) => { // 分页获取百科详情
    return fetch('/WiKi/GetFrontHealthWiKiDetailById', data)
  },
  getTokenApi: (data) => { // 获取token
    return fetch('v1.Login/getToken', data)
  },
  singleLogin: (data) => { // 单点登录
    return fetch('v1.Login/singleLogin', data)
  },
  getConfig: (data) => { // 获取设置（标题）
    return fetch('v1.Config/getConfig', data)
  },
  userLogin: (data) => { // 登录
    return fetch('v1.Login/login', data)
  },
  getTodayActivityList: (data) => { // 获取token
    return fetch('v1.Activity/getTodayActivityList', data)
  },

  getPhysicalDetailRecord: (data) => { // 获取app体检明细记录
	  return fetch('/AppPhysical/GetPhysicalDetailRecord', data)
  },
  getPhysicalDetailTrend: (data) => { // 获取app体检项目趋势
	  return fetch('/AppPhysical/GetPhysicalDetailTrend', data)
  },
  getPhysicalItemReport: (data) => { // 获取app体检项目报告（月报、周报）
	  return fetch('/AppPhysical/GetPhysicalItemReport', data)
  }
}

export default interfaces
